/**
 * @module
 *
 * @description Auto Loans driver configurations
 */
import { getAprMax, getAprMin, getFicoMin } from '../selectors/auto-loans';
import { getLoanAmountRange } from '../utils/loans';
import { getPercentageRange } from '../utils/format';
import { VALUE_SIZES } from '../constants/drivers';
/**
 * Get the estimated APR driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverEstimatedApr = function getDriverEstimatedApr(offer) {
  return {
    id: 'estApr',
    label: 'Est. APR',
    value: getPercentageRange(getAprMin(offer), getAprMax(offer)),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the loan amount driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverLoanAmount = function getDriverLoanAmount(offer) {
  return {
    id: 'loanAmount',
    label: 'Loan Amount',
    value: getLoanAmountRange(offer),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the min credit score driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMinCreditScore = function getDriverMinCreditScore(offer) {
  return {
    id: 'minCreditScore',
    label: 'Min. Credit Score',
    value: getFicoMin(offer) || 'None',
    // do not respect 0
    valueSize: VALUE_SIZES.MEDIUM
  };
};